"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { getDefaultServerSubscriptionPolicy } from "@lib/network";
import { AppStore } from "@lib/redux/types";
import { apiSlice } from "@features/application/api-slice";
import { logout } from "@features/application/app-slice";
import { resolveAuthSession } from "@features/auth/auth-session-bootstrap";
import { applyAuthSessionState } from "@features/auth/auth-session-state";
import { workspacesApi } from "@features/workspaces/workspaces-api";
type AuthSessionControllerProps = {
  store: AppStore;
};
const refetchWorkspaces = (store: AppStore) => {
  store.dispatch(workspacesApi.endpoints.getWorkspaces.initiate(undefined, {
    subscriptionOptions: getDefaultServerSubscriptionPolicy(),
    forceRefetch: true
  }));
};
export const AuthSessionController = t0 => {
  const $ = _c(4);
  const {
    store
  } = t0;
  const router = useRouter();
  let t1;
  let t2;
  if ($[0] !== router || $[1] !== store) {
    t1 = () => {
      let cancelled = false;
      resolveAuthSession().then(result => {
        if (cancelled) {
          return;
        }
        if (result.shouldResetApiState) {
          store.dispatch(apiSlice.util.resetApiState());
        }
        const {
          isAuthenticated
        } = applyAuthSessionState(store.dispatch, result.token);
        if (isAuthenticated) {
          refetchWorkspaces(store);
        }
        if (result.shouldResetApiState && isAuthenticated) {
          router.refresh();
        }
      }).catch(() => {
        if (!cancelled) {
          store.dispatch(logout());
        }
      });
      return () => {
        cancelled = true;
      };
    };
    t2 = [router, store];
    $[0] = router;
    $[1] = store;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
};